import clsx from "clsx";
import classes from "./Avatar.module.scss";
import PropTypes from "prop-types";

export default function Avatar(props) {
    const { selected, hovered, classNane, src, onClick } = props;

    return (
        <div
            onClick={onClick}
            className={clsx(classes.avatar, classNane, selected && classes.selected, hovered && classes.hovered, !!onClick && classes.clickable)}
        >
            {src && <img src={src} alt="" />}
            
            {!src && (
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd"
                        d="M51.9652 55.2782C58.5164 49.6539 62.6666 41.3115 62.6666 32C62.6666 15.0633 48.9367 1.33337 31.9999 1.33337C15.0632 1.33337 1.33325 15.0633 1.33325 32C1.33325 41.3115 5.48333 49.6539 12.0347 55.2782C14.0333 47.7611 20.8859 42.2222 29.0322 42.2222H34.9676C43.114 42.2222 49.9666 47.7611 51.9652 55.2782ZM31.6639 39.1382C38.9468 39.1382 44.8506 33.2342 44.8506 25.9514C44.8506 18.6686 38.9468 12.7647 31.6639 12.7647C24.381 12.7647 18.4771 18.6686 18.4771 25.9514C18.4771 33.2342 24.381 39.1382 31.6639 39.1382Z"
                        fill="currentColor"
                    />
                </svg>
            )}
        </div>
    )
}

Avatar.propTypes = {
    selected: PropTypes.bool,
    hovered: PropTypes.bool,
    classNane: PropTypes.string,
    src: PropTypes.string,
    onClick: PropTypes.func
};